import { Link } from 'react-router-dom';
import { productGalleryImages, productCategoryImages } from '../../../utils/images';

export default function DownJackets() {
  const downProducts = productGalleryImages.downJackets;

  return (
    <div>
      {/* Hero Section */}
      <section className="relative h-[60vh] bg-cover bg-center bg-no-repeat flex items-center justify-center"
               style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url(${productCategoryImages.downJackets})` }}>
        <div className="text-center text-white max-w-4xl mx-auto px-4">
          <h1 className="text-5xl lg:text-6xl font-light mb-6 leading-tight">
            Puffer
          </h1>
          <p className="text-xl leading-relaxed font-light max-w-2xl mx-auto">
            Performance-driven outerwear combining functionality with contemporary style
          </p>
        </div>
      </section>

      {/* Products Gallery */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {downProducts.map((image, index) => (
              <div key={index} className="group">
                <div className="relative overflow-hidden">
                  <img
                    src={image}
                    alt={`Puffer ${index + 1}`}
                    className="w-full h-[600px] object-contain group-hover:scale-105 transition-transform duration-500"
                  />
                    </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="text-4xl font-light mb-6">Performance Outerwear Manufacturing</h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Technical expertise in down and woven outerwear for global fashion brands
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <button className="px-8 py-3 bg-black text-white hover:bg-gray-800 transition-colors">
                Get Quote
              </button>
            </Link>
            <Link to="/services">
              <button className="px-8 py-3 border border-black text-black hover:bg-black hover:text-white transition-colors">
                Our Services
              </button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}